// Teletel: the product ships in Arabic and English ONLY — see
// app/javascript/dashboard/i18n/index.js and config/initializers/languages.rb.
// The other locale JSON files stay on disk, unimported, so the customer-facing
// widget bundle carries two languages instead of forty.
import ar from './locale/ar.json';
import en from './locale/en.json';

export default {
  ar,
  en,
};
